// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root___Lggb","title":"Header_title__2l9Od","left":"Header_left__3x0ZY","clinicName":"Header_clinicName__1Yp27"};